/**
 * Public pricing page chrome only (hero / FAQ / trust).
 * Plan cards (name, price, features) come from GET /api/v1/subscriptions/plans — never hardcode here.
 */
export const PRICING_HERO = {
  kicker: 'Transparent Infrastructure Tiers',
  headline: 'Simple, Production-Scale Pricing',
  headlineAccent: null,
  lead:
    'No hidden usage fees, opaque overage charges, or credit card requirements to start. Get started locally for free, or expand your processing limits to match enterprise team scales.',
  subLead:
    'Flexible Plans for Every Scale — choose the environment that fits your workflow. Start locally for free, or scale across your entire data engineering team.',
  usdNotice:
    'All prices are in USD (US Dollars). Paid subscriptions renew automatically each billing period until you cancel in your account settings or by contacting sales@candorsys.com.',
  footnote:
    'Plan names, prices, and features are loaded from the live catalog. Contact sales for Enterprise volume, air-gapped, and custom compliance.',
  taxNote:
    'Taxes may apply based on your billing location and will be calculated at checkout.',
  paddleB2bNote:
    'Paddle securely supports business-to-business (B2B) transactions with automated corporate tax ID validation, as well as individual consumer (B2C) checkouts.',
  trustChips: [
    { id: 'paddle', label: 'Secure payments via Paddle' },
    { id: 'guarantee', label: '30-day money-back guarantee' },
    { id: 'renewal', label: 'Auto-renewal disclosed' },
  ],
  yearlyDiscountPercent: 20,
  yearlyDiscountBadge: '-20%',
};

export const PRICING_TRUST_STRIP = {
  title: 'Enterprise Compliance & Security Guarantees',
  items: [
    {
      title: 'Zero Row-Level Data Ingestion',
      body: 'Candor interrogates schema catalogs only; raw data never leaves your infrastructure.',
    },
    {
      title: 'Host OS Keychain Protection',
      body: 'Database host passwords are encrypted natively via Windows DPAPI or macOS Keychain.',
    },
    {
      title: 'Air-Gapped Local Execution',
      body: 'Unhook processing pipelines completely from external APIs using local open-weights model nodes.',
    },
  ],
};

export const PRICING_FAQ = [
  {
    q: 'Do I need a credit card to access the free Community tier?',
    a: 'No. You can claim your local hardware license and free AI context tokens by authenticating your profile via GitHub or Google Workspace. Limits and features are defined in the live pricing catalog.',
  },
  {
    q: 'How does Candor protect my database credentials and metadata?',
    a: 'Candor operates on a zero-trust, local-first architecture. Database connection strings and host credentials remain encrypted on your machine using native OS keychains (Windows DPAPI / macOS Keychain). No central server ever receives or stores your database access keys.',
  },
  {
    q: 'Does Candor read or copy my actual table rows?',
    a: 'Never. Candor exclusively interrogates system catalog schemas, column configurations, DDL definitions, and constraint frameworks to generate accurate SQL, dbt, and Python models. It contains zero routines capable of copying or exfiltrating underlying row data.',
  },
  {
    q: 'What happens when I exhaust my free processing tokens?',
    a: 'You can upgrade to a paid tier from the live catalog for higher allocation limits, or contact sales for Enterprise volume and custom compliance options.',
  },
];

export const TRUSTED_PAYMENT = {
  title: 'Trusted Payment Experience',
  body:
    'All payments are securely processed through Paddle.com Market Ltd., which acts as the Merchant of Record for all transactions.',
  bodyExtended:
    'As the Merchant of Record, Paddle is responsible for securely handling payment processing, billing, sales tax, VAT, GST collection, invoicing, and regulatory compliance where applicable.',
  ideNote:
    'Accounts can be created from this console. Paid subscriptions are also available inside the Candor IDE desktop application.',
  needHelpTitle: 'Need Help?',
  needHelpBody: 'Contact us for custom billing inquiries or invoice reconciliation.',
};
